import $i from "~/i18n";

export const inMobile = ({ state, commit }, mobile) => {
  commit("SET_DATA", { data: mobile, id: "mobile" });
  return mobile;
};

export const sendMsg = async ({ commit }, payload) => {
  try {
    let { data } = await axios.post("/contact-us", payload);
    if (data.state != 200) {
      if (data.state == 404) {
        commit(
          "notifications/error",
          { message: "کد تخفیف یافت نشد", title: "خطای کد تخفیف" },
          { root: true }
        );
      }
      return;
    }
    commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
  } catch (error) {
    console.log(error);
  }
};
export const newsLatter = async ({ commit }, payload) => {
  try {
    let { data } = await axios.post("/newsletter", payload);
    if (data.state !== 200) return;
    commit(
      "notifications/success",
      { message: "ایمیل شما با موفقیت ذخیره شد", title: "" },
      { root: true }
    );
  } catch (error) {
    console.log(error);
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js